<template>
<div>
  <v-radio-group v-model="ringtone" mandatory class='mt-1'>

    <v-radio v-for='r in ringtones' :key='r.name' :label='r.name' :value='r'>
    </v-radio>
  </v-radio-group>
</div>
</template>

<script >
import { mapState } from 'vuex';

export default {
  computed: {
    ringtone: {
      get() {return this.$store.state.ringtone;},
      set(ringtone) {this.$store.commit('ringtone', ringtone);}
    },
    ...mapState(['userId', 'ringtones']),
  },

  methods: {  },
  watch: {
    ringtone: function(newRingtone, oldRingtone) {
      if(!oldRingtone.audio.paused){oldRingtone.audio.pause(); oldRingtone.audio.currentTime = 0.0;}
    }
  },
  mounted() {
    console.log('select-ringtone mounted');
    console.log(this.ringtones);
   },
  beforeMount() { },

}
</script>
